import { getUserDetails } from "../components/DoctorMangement/Helper/utils";
import { MBAnalytics } from "./analytics-helper";
const SNOWPLOW = 'snowplow';
const WEB= 'web';
const __MB_Analytics = new MBAnalytics([SNOWPLOW]);




export const fetchUserDetailsAndSetUserForAnalytics = async () => {
    try {
      if (typeof window == "undefined") return;
      const userDetails = getUserDetails()
      userDetails && setUserAnalyticsInfo(userDetails);
  
    } catch (error) {
      console.log("** ERROR WHILE STORING USER INFORMATION **", error);
    }
  };


  export const setUserAnalyticsInfo = (details) => {
    const {
      firstName,
      lastName,
      userName,
      entityName,
      userEmail,
      providerId,
      userId,
      parentId
 

    } = details


    try {
      __MB_Analytics.trackUserOnLogin({
        firstName,
        lastName,
        userName,
        entityName,
        userEmail,
        providerId,
        userId,
        parentId
      });
    } catch (error) {
      console.log("** ERROR WHILE SENDING EVENTS FOR USER DETAILS **", error);
    }
  };



  function cleanPayload(payload){
    return Object.fromEntries(
      Object.entries(payload)
          .filter(([key, value]) => value !== null && value !== undefined)
  );
  }

  export async function logEventToAnalyticsPlatform(event) {

    if (event && event.name && event.schema && event.payload) {
      const enrichedPaylod = { ...event.payload,};
      const cleanedPayload = cleanPayload(enrichedPaylod);
      __MB_Analytics.sendToSnowplow(event.schema, cleanedPayload);
  
    }
  }
  

  